export default "__VITE_ASSET__CY0LrNww__"